// The backend never reads the filename — it matches the multipart part name and then sniffs
// magic bytes. This exists so a clip from the Safari MP4 fallback is not labelled `.webm` in
// every log that touches it.
const EXTENSIONS: [test: string, extension: string][] = [
  ["webm", "webm"],
  ["ogg", "ogg"],
  ["mp4", "m4a"],
  ["mpeg", "mp3"],
];

const audioFileExtension = (mimeType: string): string => {
  const found = EXTENSIONS.find(([test]) => mimeType.includes(test));
  return found ? found[1] : "webm";
};

export default audioFileExtension;
